import { render, staticRenderFns } from "./InsideContent.vue?vue&type=template&id=10e4bb36"
import script from "./InsideContent.vue?vue&type=script&lang=js"
export * from "./InsideContent.vue?vue&type=script&lang=js"
import style0 from "./InsideContent.vue?vue&type=style&index=0&id=10e4bb36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports